import { render, staticRenderFns } from "./statistics-revenue.vue?vue&type=template&id=75b74088&scoped=true&"
import script from "./statistics-revenue.vue?vue&type=script&lang=js&"
export * from "./statistics-revenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b74088",
  null
  
)

export default component.exports